// "Zablokuj" / "Zgłoś". Mirrored in packages/shared/src/domain/moderation.ts.
// Rules: .claude/skills/moderation.

export const REPORT_DETAILS_MAX_LENGTH = 500;

/** In the order the report dialog lists them. */
export const REPORT_REASONS = [
  { value: "harassment", label: "Nękanie lub zaczepki" },
  { value: "inappropriate", label: "Nieodpowiednie treści" },
  { value: "spam", label: "Spam" },
  { value: "fake", label: "Fałszywe konto" },
  { value: "other", label: "Inny powód" },
];

export const reportReasonLabel = (reason) => REPORT_REASONS.find((r) => r.value === reason)?.label ?? reason;

/** What blocking does, shown before the user confirms. */
export const blockConfirmMessage = (name) =>
  `${name} zniknie z Twoich znajomych i Tablicy, a wspólne zapisy i zgody na karnety zostaną wyłączone. ` +
  "Nie będziecie mogli się wyszukać ani zaprosić. Ta osoba nie dostanie powiadomienia. " +
  "Odblokować możesz w Znajomi → Zablokowani.";
